import { render, staticRenderFns } from "./OverAssignedComponent.vue?vue&type=template&id=61782173&scoped=true&"
import script from "./OverAssignedComponent.vue?vue&type=script&lang=js&"
export * from "./OverAssignedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61782173",
  null
  
)

export default component.exports